import { Link } from "office-ui-fabric-react"

const GlobalCalendarExceptionsListTooltip = () => {
    return <div>Define calendar exceptions (national/international holidays, company holidays, etc.) to ensure that work is not scheduled on days when your organization is not operating. Please note that managing this setting requires the 'Manage Resources' permission.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/621569-calendar" target="_blank">article</Link> for more details.</div>
}

export default GlobalCalendarExceptionsListTooltip;